<template>
  <b-card class="mx-auto" style="max-width: 600px;margin:50px" v-if="!success">
    <h3 class="mb-3 text-center">Inscription</h3>
    <p class="text-muted small mb-3">
      <span class="required-asterisk">*</span> Champs obligatoires
    </p>
    <b-form @submit.prevent="handleRegister">
      <h5 class="section-title">Identité</h5>

      <b-form-group label-for="name">
        <template #label>
          Prénom <span class="required-asterisk">*</span>
        </template>
        <b-form-input
          id="name"
          type="text"
          v-model="form.name"
          :state="nameState"
          maxlength="50"
          required
          placeholder="ex: Jean"
        />
        <b-form-invalid-feedback :state="nameState">
          1 à 50 caractères, lettres, espaces, apostrophes et tirets uniquement.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="surname">
        <template #label>
          Nom de famille <span class="required-asterisk">*</span>
        </template>
        <b-form-input
          id="surname"
          type="text"
          v-model="form.surname"
          :state="surnameState"
          maxlength="50"
          required
          placeholder="ex: Dupont"
        />
        <b-form-invalid-feedback :state="surnameState">
          1 à 50 caractères, lettres, espaces, apostrophes et tirets uniquement.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="bornAt">
        <template #label>
          Date de naissance <span class="required-asterisk">*</span>
        </template>
        <b-form-input
          id="bornAt"
          type="date"
          v-model="form.bornAt"
          :state="bornAtState"
          :min="minBornAt"
          :max="maxBornAt"
          required
        />
        <b-form-invalid-feedback :state="bornAtState">
          Date invalide (doit être passée et postérieure à 1900).
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="gender">
        <template #label>
          Genre <span class="required-asterisk">*</span>
        </template>
        <b-form-select
          id="gender"
          v-model="form.gender"
          :options="genderOptions"
          required
        />
      </b-form-group>

      <hr class="section-divider">
      <h5 class="section-title">Coordonnées</h5>

      <b-form-group label-for="phoneNumber">
        <template #label>
          Numéro de téléphone <span class="required-asterisk">*</span>
        </template>
        <b-form-input
          id="phoneNumber"
          type="tel"
          v-model="form.phoneNumber"
          :state="phoneNumberState"
          maxlength="25"
          required
          placeholder="ex: 06 12 34 56 78"
        />
        <b-form-invalid-feedback :state="phoneNumberState">
          8 à 15 chiffres. Caractères autorisés : chiffres, +, espaces, ., -, parenthèses.
        </b-form-invalid-feedback>
      </b-form-group>


      <b-form-group label-for="email">
        <template #label>
          Adresse e-mail <span class="required-asterisk">*</span>
        </template>
        <b-form-input
          id="email"
          type="email"
          v-model="form.email"
          :state="emailState"
          maxlength="254"
          required
          placeholder="ex: jean@example.com"
        />
        <b-form-invalid-feedback :state="emailState">
          Adresse e-mail invalide.
        </b-form-invalid-feedback>
      </b-form-group>

      <hr class="section-divider">
      <h5 class="section-title">Sécurité</h5>

      <b-form-group label-for="password">
        <template #label>
          Mot de passe <span class="required-asterisk">*</span>
        </template>
        <b-form-input
          id="password"
          type="password"
          v-model="form.password"
          :state="passwordState"
          minlength="8"
          maxlength="150"
          required
          placeholder="Choisissez un mot de passe"
        />
        <b-form-invalid-feedback :state="passwordState">
          Le mot de passe doit contenir entre 8 et 150 caracteres.
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="confirmPassword">
        <template #label>
          Confirmer le mot de passe <span class="required-asterisk">*</span>
        </template>
        <b-form-input
          id="confirmPassword"
          type="password"
          v-model="form.confirmPassword"
          :state="confirmPasswordState"
          minlength="8"
          maxlength="150"
          required
          placeholder="Retapez le mot de passe"
        />
        <b-form-invalid-feedback :state="confirmPasswordState">
          Les mots de passe ne correspondent pas.
        </b-form-invalid-feedback>
        <b-form-valid-feedback :state="confirmPasswordState">
          Les mots de passe correspondent.
        </b-form-valid-feedback>
      </b-form-group>

      <hr class="section-divider">
      <h5 class="section-title">Consentements</h5>

      <b-form-group label-for="newsletter">
        <b-form-checkbox
          id="checkbox-1"
          v-model="form.newsletter"
          name="checkbox-1"
          value="true"
          unchecked-value="false"
        >
          Je souhaite recevoir la newsletter occasionnelle.
        </b-form-checkbox>
      </b-form-group>

      <b-form-group label-for="newsletter">
        <b-form-checkbox
          id="checkbox-2"
          v-model="form.photoConsent"
          name="checkbox-2"
          value="true"
          unchecked-value="false"
        >
          J'accepte d’être filmé ou photographié par le GUC Voile.
        </b-form-checkbox>
      </b-form-group>

      <b-form-group label-for="newsletter">
        <b-form-checkbox
          id="checkbox-3"
          v-model="form.swimmingConsent"
          name="checkbox-3"
          value="true"
          unchecked-value="false"
        >
          Je déclare être apte à plonger et nager 50 mètres.
        </b-form-checkbox>
      </b-form-group>

      <b-form-group label-for="newsletter">
        <b-form-checkbox
          id="checkbox-4"
          v-model="form.reglementConsent"
          name="checkbox-4"
          required
        >
          J’ai lu et j’accepte le <a :href="reglementUrl" target="_blank" download="reglement-guc-voile.pdf">règlement du GUC Voile.</a>
          <span class="required-asterisk">*</span>
        </b-form-checkbox>
      </b-form-group>

      <b-button type="submit" variant="primary" block :disabled="!canSubmit">
        Créer un compte
      </b-button>

      <b-alert
        v-if="error"
        variant="danger"
        show
        class="mt-3"
      >
        {{ error }}
      </b-alert>


    </b-form>
  </b-card>
  <b-card v-else
    class="mx-auto success-card"
    style="max-width: 600px;margin:50px"
    >
    <div class="success-header mb-1">
      <b-icon icon="check-circle-fill" class="success-icon mr-2" />
      <p class="success-title mb-0">Compte créé avec succès.</p>
    </div>
    <p class="success-text mb-2">
      Votre inscription a bien été enregistrée.
    </p>
    <p class="success-text mb-2" style="font-weight: bold;">
      Pour finaliser l'activation de votre compte, ouvrez l'e-mail que nous venons de vous envoyer puis cliquez sur le lien d'activation.
    </p>
  </b-card>
</template>

<script>
import axios from 'axios';
import UserService from '@/services/user.service';

const NAME_REGEX = /^[\p{L}\p{M}'\- ]{1,50}$/u;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_ALLOWED_CHARS = /^[+0-9 .()\-]+$/;

export default {
  name: "RegisterForm",
  data() {
    return {
      form: {
        name: '',
        surname: '',
        bornAt: '',
        gender: '',
        phoneNumber: '',
        email: '',
        password: '',
        confirmPassword: '',
        newsletter: false,
        photoConsent: false,
        swimmingConsent: false,
        reglementConsent: false
      },
      error: null,
      success: false,
      genderOptions: [
        { value: '', text: 'Sélectionner une option' },
        { value: 'home', text: 'Homme' },
        { value: 'femme', text: 'Femme' },
        { value: 'ne souhaite pas répondre', text: 'Ne souhaite pas répondre' }
      ]
    };
  },
  computed: {
    reglementUrl() {
      return (axios.defaults.baseURL || '') + 'app-settings/reglement';
    },
    minBornAt() {
      return '1900-01-01';
    },
    maxBornAt() {
      return new Date().toISOString().slice(0, 10);
    },
    isNameValid() {
      return NAME_REGEX.test((this.form.name || '').trim());
    },
    isSurnameValid() {
      return NAME_REGEX.test((this.form.surname || '').trim());
    },
    isEmailValid() {
      const email = (this.form.email || '').trim();
      return email.length > 0 && email.length <= 254 && EMAIL_REGEX.test(email);
    },
    isPhoneNumberValid() {
      const phone = (this.form.phoneNumber || '').trim();
      if (!phone || phone.length > 25 || !PHONE_ALLOWED_CHARS.test(phone)) return false;
      const digits = phone.replace(/\D/g, '');
      return digits.length >= 8 && digits.length <= 15;
    },
    isBornAtValid() {
      if (!this.form.bornAt) return false;
      const date = new Date(this.form.bornAt);
      if (Number.isNaN(date.getTime())) return false;
      const now = new Date();
      const min = new Date('1900-01-01');
      return date <= now && date >= min;
    },
    nameState() {
      if (!this.form.name) return null;
      return this.isNameValid;
    },
    surnameState() {
      if (!this.form.surname) return null;
      return this.isSurnameValid;
    },
    emailState() {
      if (!this.form.email) return null;
      return this.isEmailValid;
    },
    phoneNumberState() {
      if (!this.form.phoneNumber) return null;
      return this.isPhoneNumberValid;
    },
    bornAtState() {
      if (!this.form.bornAt) return null;
      return this.isBornAtValid;
    },
    isPasswordLengthValid() {
      const length = (this.form.password || "").length;
      return length >= 8 && length <= 150;
    },
    passwordsMatch() {
      return this.form.password === this.form.confirmPassword;
    },
    passwordState() {
      if (!this.form.password) return null;
      return this.isPasswordLengthValid;
    },
    confirmPasswordState() {
      if (!this.form.confirmPassword) return null;
      if (!this.isPasswordLengthValid) return false;
      return this.passwordsMatch;
    },
    canSubmit() {
      return (
        this.isPasswordLengthValid &&
        this.passwordsMatch &&
        this.isNameValid &&
        this.isSurnameValid &&
        this.isBornAtValid &&
        !!this.form.gender &&
        this.isPhoneNumberValid &&
        this.isEmailValid &&
        this.form.reglementConsent === true
      );
    }
  },
  methods: {
    async handleRegister() {
      this.error = null;
      this.success = false;

      if (!this.isNameValid) {
        this.error = "Prénom invalide.";
        return;
      }
      if (!this.isSurnameValid) {
        this.error = "Nom invalide.";
        return;
      }
      if (!this.isBornAtValid) {
        this.error = "Date de naissance invalide.";
        return;
      }
      if (!this.form.gender) {
        this.error = "Veuillez sélectionner un genre.";
        return;
      }
      if (!this.isPhoneNumberValid) {
        this.error = "Numéro de téléphone invalide.";
        return;
      }
      if (!this.isEmailValid) {
        this.error = "Adresse e-mail invalide.";
        return;
      }
      if (!this.isPasswordLengthValid) {
        this.error = "Le mot de passe doit contenir entre 8 et 150 caracteres.";
        return;
      }

      if (this.form.password !== this.form.confirmPassword) {
        this.error = "Les mots de passe ne correspondent pas.";
        return;
      }

      if (!this.form.reglementConsent) {
        this.error = "Vous devez accepter le reglement du GUC Voile.";
        return;
      }

      try {
        const res = await UserService.register({
          name: this.form.name.trim(),
          surname: this.form.surname.trim(),
          bornAt: this.form.bornAt,
          gender: this.form.gender,
          phoneNumber: this.form.phoneNumber.trim(),
          email: this.form.email.trim().toLowerCase(),
          password: this.form.password,
          newsletter: this.form.newsletter,
          photoConsent: this.form.photoConsent,
          swimmingConsent: this.form.swimmingConsent,
          reglementConsent: this.form.reglementConsent

        });

        const data = await res.data;

        if (res.status !== 200 || data.error) {
          this.error = data.error || "Erreur d'inscription.";
        } else {
          this.success = true;
          this.form.email = "";
          this.form.password = "";
          this.form.confirmPassword = "";
          this.form.bornAt = "";
          this.form.gender = "";

          // setTimeout(() => {
          //   this.$router.push("/?login=required");
          // }, 4000);
        }
      } catch (err) {
        console.error("Erreur réseau :", err);
        this.error = err;
      }
    }
  }
};
</script>

<style scoped>
.required-asterisk {
  color: #dc3545;
  font-weight: 700;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.75rem;
}

.section-divider {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 1.25rem 0 1rem;
}

.success-card {
  border: 1px solid #d8e2dc;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.06);
  color: #1f2937;
}

.success-title {
  font-size: 1rem;
  font-weight: 600;
}

.success-header {
  display: flex;
  align-items: center;
}

.success-icon {
  color: #2f855a;
}

.success-text {
  color: #4b5563;
  line-height: 1.5;
}
</style>
